let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aPdi5")).then(() => parcelRequire('3RUiT'));